// Mínimo da Apple HIG para alvo de toque. Vale só abaixo de sm, onde o toque é o uso normal: o
// desktop segue com os tamanhos de mouse. O mínimo fica no tema, e não em cada tela, porque a
// auditoria do CKTPL-1431 achou alvos de desktop em 13 de 15 telas.
export const TOUCH_TARGET_SIZE = 44;

export const belowSm = (theme, styles) => ({ [theme.breakpoints.down('sm')]: styles });

// Para o botão cujo desenho não pode crescer (círculo escuro por cima de uma imagem): o `sx`
// responsivo devolve a caixa ao tamanho do desenho, porque vence o mínimo do tema, e o `::after`
// transparente recebe o toque em 44 px em volta dele.
export const touchAreaAroundSx = {
  minWidth: { xs: 0 },
  minHeight: { xs: 0 },
  '&::after': {
    content: '""',
    display: { xs: 'block', sm: 'none' },
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: TOUCH_TARGET_SIZE,
    height: TOUCH_TARGET_SIZE,
    transform: 'translate(-50%, -50%)',
  },
};
